import { useState, useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import '../../styles/BrigadePlaceWork.css';
import Table from '../Table/Table';
import CustomButton from '../CustomElements/CustomButton';
import Modal from '../Modal/Modal';
import MyMap from '../Maps/MyMap';
import ChoosePlaceWork from './ChoosePlaceWork';
import BrigadeWayOut from './BrigadeWayOut';
import BrigadeTransferFencingAllowed from './BrigadeTransferFencingAllowed';
import { defaultCellRender } from '../../utils/formatValueForHTML';
import {
  emitPlaceWorkListenStart,
  emitPlaceWorkListenStop, emitWayOut,
  emitTransferStart
} from '../../redux/actions/brigades.action';
import { listenPlaceWorkInfo, listenCurrentLocationWorkInfo } from '../../redux/actions/brigades.action';
import { transformsUippsCoords } from '../../utils/transformsUippsCoords';
import { useRole } from '../../customHook/useRole';

function BrigadePlaceWork({ currentBrigade, t }) {
  // Получение функции dispatch для отправки действий в Redux store.
  const dispatch = useDispatch();
  //данные из стейта текущее место работы
  const { currentLocationsWork, brigadeSignals, brigadeInfo } = useSelector((state) => state.brigadesState);
  // Состояния для отображения компонентов и модального окна
  const [confirmTextBtn, setConfirmTextBtn] = useState('');

  //проверяем роли пользователя
  const isAdmin = useRole('admin');
  const isMaster = useRole('master');
  const isCustomer = useRole('customer');
  const isDispatcher = useRole('dispatcher');
  const isEngineerInfosignal = useRole('engineerInfosignal');

  const [isOpen, setIsOpen] = useState(false);
  const [choosePlaceWork, setChoosePlaceWork] = useState(false);
  const [brigadeWayOut, setBrigadeWayOut] = useState(false);
  const [openBrigadeTransferFencingAllowed, setOpenBrigadeTransferFencingAllowed] = useState(false);

  const [message, setMessage] = useState(
    brigadeSignals?.signals?.length > 0 ? t.wayOutForbiddenMessage : t.wayOutSafeMessage
  );

  useEffect(() => {
    setMessage(brigadeSignals?.signals?.length > 0 ? t.wayOutForbiddenMessage : t.wayOutSafeMessage);
  }, [brigadeSignals?.signals?.length, t.wayOutForbiddenMessage, t.wayOutSafeMessage]);

  const [currentPW, setCurrentPW] = useState('');
  const [title, setTitle] = useState();

  //открытие модалки для выхода на путь
  const wayOut = () => {
    setBrigadeWayOut(true);
    setIsOpen(true);
  };

  //открытие модалки для начала переноса
  const openStartTransfer = () => {
    setOpenBrigadeTransferFencingAllowed(true);
    setIsOpen(true);
  };

  //старт переноса
  const startTransfer = () => {
    const payload = { brigadeId: currentBrigade?.id };
    dispatch(emitTransferStart(payload));
    closeModal();
  };

  const handlerConfirm = () => {
    // отправить сигнал 'exit_rails' payload - {brigadeId: number}
    dispatch(emitWayOut({ brigadeId: currentBrigade?.id }));
    closeModal();
  };
  // Закрыть модальное окно
  const closeModal = () => {
    setIsOpen(false);
    setChoosePlaceWork(false);
    setBrigadeWayOut(false);
    setOpenBrigadeTransferFencingAllowed(false);
  };
  // Колонки таблицы
  const formatKuobzAlert = (value) => {
    switch (value) {
      case 1:
        return 'ОК';
      case 2:
        return t?.notification1;
      case 3:
        return t?.notification2;
      case 4:
        return t?.alertNoConnection;
      case 5:
        return t?.alert;
      case 6:
        return t?.waiting;
      default:
        return '-';
    }
  };

  // Мемоизация списка маркеров
  const markers = useMemo(
    () => [
      // Добавляем специфический маркер для бригады в начало массива
      {
        position: [brigadeSignals?.iurLat, brigadeSignals?.iurLon],
        type: 'green',
        popupContent: `${t?.brigade} № ${currentBrigade?.id}`,
      },
      // Добавляем остальные маркеры, преобразованные из inputArray
      ...transformsUippsCoords(brigadeSignals?.uippsCoords),
      ...transformsUippsCoords(brigadeSignals?.kuobzCoords, true),
    ],
    [
      brigadeSignals?.iurLat,
      brigadeSignals?.iurLon,
      brigadeSignals?.uippsCoords,
      brigadeSignals?.kuobzCoords,
      currentBrigade?.id,
      t,
    ]
  );

  const columnsTableSignal = useMemo(
    () =>
      [
        {
          Header: '№',
          Cell: ({ row }) => {
            return <span>{row.index + 1}</span>;
          },
        },
        {
          Header: t?.uippsID,
          accessor: 'uippsId',
          Cell: ({ value }) => defaultCellRender(value),
        },
        {
          Header: t?.direction,
          accessor: 'direction',
          Cell: ({ value }) => (value === 1 ? t?.oddDirection : t?.evenDirection),
        },
        {
          Header: t?.route,
          accessor: 'isAdjacentRail',
          Cell: ({ row }) => {
            const label = row.original.isAdjacentRail ? t?.pathAdjacent : t?.pathNotAdjacent;
            const railName = row.original.railName;
            return <span>{railName ? `${label} - ${railName}` : label}</span>;
          },
        },
        (isAdmin || isEngineerInfosignal || isCustomer) && {
          Header: t?.columnSignalDistanceToPs,
          accessor: 'distance',
          Cell: ({ row }) => (
            <div>
              <div>{`${t?.apkDkDistance}${row?.original?.distanceApkDk}`}</div>
              <div>{`${t?.distanceSadr}${row?.original?.distanceSadr}`}</div>
            </div>
          ),
        },
        {
          Header: t?.railsHeader,
          accessor: 'rails',
          Cell: ({ row }) => (
            <div>
              <div>{`${t?.railsWarning}: ${row.original.railsWarning}`}</div>
              <div>{`${t?.alert}: ${row.original.railsAlert}`}</div>
            </div>
          ),
        },
        {
          Header: t?.columnSignalAlert,
          accessor: 'uippsAlert',
          Cell: ({ row }) => (
            <div>
              {row.original.uippsAlert !== undefined && (
                <div>
                  УИППС:{' '}
                  {(function (value) {
                    switch (Number(value)) {
                      case 0:
                        return 'ОК';
                      case 1:
                        return t?.alert;
                      case 6:
                        return t?.waiting;
                      default:
                        return '-';
                    }
                  })(row.original.uippsAlert)}
                </div>
              )}
              {row.original.kuobzAlert !== undefined && <div>КУОБЗ: {formatKuobzAlert(row.original.kuobzAlert)}</div>}
              <div>ИУР: {formatKuobzAlert(row.original.alertType)}</div>
            </div>
          ),
        },
      ].filter(Boolean),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [brigadeSignals?.signals, t, isAdmin, isEngineerInfosignal, isCustomer]
  );

  // Колонки таблицы
  const columns = useMemo(
    () =>
      [
        {
          Header: t?.tableHeaderRoad || 'Дорога',
          accessor: 'road',
          Cell: ({ value }) => defaultCellRender(value),
        },
        {
          Header: t?.tableHeaderStation || 'Станция/Перегон',
          accessor: 'station',
          Cell: ({ value }) => defaultCellRender(value),
        },
        {
          Header: t?.tableHeaderOrd || 'Ордината места работ',
          accessor: 'ord',
          Cell: ({ value }) => defaultCellRender(value),
        },
        {
          Header: t?.tableHeaderObject || 'Объект',
          accessor: 'obj',
          Cell: ({ value }) => <span className="text-nowrap">{defaultCellRender(value)}</span>,
        },
        {
          Header: t?.tableHeaderRail || 'РЦ',
          accessor: 'rail',
          Cell: ({ value }) => defaultCellRender(value),
        },
        {
          Header: t?.tableHeadeAdjacentRails || 'Смежные РЦ',
          accessor: 'adjacentRails',
          Cell: ({ value }) => defaultCellRender(value),
        },
        {
          Header: t?.iurCoordinates,
          accessor: 'iurCoordinates',
          Cell: () => (
            <div className="no-wrap">{`${defaultCellRender(brigadeSignals?.iurLat)}, ${defaultCellRender(
              brigadeSignals?.iurLon
            )}`}</div>
          ),
        },
      ]?.filter(Boolean),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [brigadeSignals?.iurLat, brigadeSignals?.iurLon, isAdmin, isEngineerInfosignal, t]
  );
  useEffect(() => {
    //отправляем событие чтобы сервер начал слать инфо
    dispatch(emitPlaceWorkListenStart({ brigadeId: currentBrigade.id }));
    //слушаем событие 'info'
    dispatch(listenPlaceWorkInfo());
    //слушаем событие 'work_place_info'
    dispatch(listenCurrentLocationWorkInfo());

    // Функция очистки
    return () => {
      // отправляем событие чтобы сервер закончил слать инфо
      dispatch(emitPlaceWorkListenStop({ brigadeId: currentBrigade.id }));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <div className="brigade-place-work-table-container">
        {!brigadeInfo?.inWork && <div className="">{t?.noWorkMessage || 'На данный момент бригада не работает.'}</div>}
        {/*если работы не начаты то скрыть всю информацию оставив только кнопку "Назначить место работ"  */}
        {brigadeInfo?.inWork && (
          <>
            {/* Таблица с данными о текущем месте работ */}
            <Table data={[currentLocationsWork || {}]} columns={columns} />
            {(isAdmin || isCustomer || isEngineerInfosignal || isMaster || isDispatcher) &&
              !brigadeSignals?.isExitRails && (
                <>
                  {/* Блок с предупреждающим сообщением, если есть сигналы выход запрещен, красный цвет */}
                  {/* Если сигналов нет выход разрешен, зеленым цветом */}
                  <div
                    className="brigade-place-work-info"
                    style={{ color: brigadeSignals?.signals?.length > 0 ? 'var(--sadr-error)' : 'var(--sadr-success)' }}
                  >
                    {message}
                  </div>
                  {/* Кнопка выхода на путь должна отображаться только когда нет сигналов и бригада не вышла на путь и пользователь в роли admin*/}
                  {
                    // Проверяем:
                    // 1. Пользователь админ или инженер
                    // 2. Бригада не вышла на путь
                    // 3. И кнопки у текущей бригады разрешены
                    (isAdmin || isEngineerInfosignal) &&
                    !brigadeSignals?.isExitRails &&
                    currentBrigade?.enableButtons && (
                      <div className="brigade-place-work-btn-container">
                        <CustomButton text={t?.exitWayButton} onClick={wayOut} />
                      </div>
                    )
                  }
                </>
              )}
            {(isAdmin || isCustomer || isEngineerInfosignal) &&
              brigadeInfo?.state === 4 &&
              brigadeSignals?.signals?.length === 0 && (
                <>
                  {/* Блок с текстом и кнопкой перенос */}
                  <div
                    className="brigade-place-work-info"
                    style={{ color: brigadeSignals?.signals?.length > 0 ? 'var(--sadr-error)' : 'var(--sadr-success)' }}
                  >
                    {t?.transferAllowedMessage}
                  </div>

                  {/* Кнопка начать перенос */}
                  {brigadeInfo?.state === 4 &&
                    brigadeSignals?.signals?.length === 0 &&
                    (isAdmin || isEngineerInfosignal) && (
                      <div className="brigade-place-work-btn-container">
                        <CustomButton text={t?.transferStartButton} onClick={openStartTransfer} disabled={false} />
                      </div>
                    )}
                </>
              )}

            {/*Таблица сигналов */}
            {brigadeSignals?.signals && (
              <Table
                className="customBorderRadius"
                data={brigadeSignals?.signals || []}
                columns={columnsTableSignal}
                colorTR={true}
              />
            )}

            {/* Карта, требуется передавать координаты */}
            <div className="brigade-place-work-map-container">
              <MyMap markers={markers} />
            </div>
          </>
        )}
        {/* [brigadeSignals?.iurLat, brigadeSignals?.iurLon] */}
      </div>
      {/* Модальное окно */}
      <Modal isOpen={isOpen} onClose={closeModal} containerSelector={'.brigades_content'}>
        {choosePlaceWork && (
          <ChoosePlaceWork
            onClose={closeModal}
            title={title}
            currentPW={currentPW}
            setCurrentPW={setCurrentPW}
            currentBrigade={currentBrigade}
            confirmTextBtn={confirmTextBtn}
            t={t}
          />
        )}
        {brigadeWayOut && <BrigadeWayOut closeModal={closeModal} handlerConfirm={handlerConfirm} t={t} />}
        {openBrigadeTransferFencingAllowed && (
          <BrigadeTransferFencingAllowed closeModal={closeModal} handlerConfirm={startTransfer} t={t} />
        )}
      </Modal>
    </>
  );
}

export default BrigadePlaceWork;
